// 8 départements d'Île-de-France desservis par cartonmove.
// Chaque entrée alimente la page SEO dynamique /cartons-demenagement/:slug.

const DEPARTMENTS = [
  {
    slug: "paris",
    code: "75",
    name: "Paris",
    nameWithArticle: "à Paris",
    templateId: "paris",
    cities: [
      "Tous les arrondissements (1er au 20e)",
      "Centre, Rive Droite, Rive Gauche",
    ],
    intro:
      "Tous les arrondissements de Paris (75001 à 75020) sont desservis sous 24-48 h.",
  },
  {
    slug: "seine-et-marne",
    code: "77",
    name: "Seine-et-Marne",
    nameWithArticle: "en Seine-et-Marne",
    templateId: "seine-et-marne",
    cities: [
      "Meaux", "Melun", "Chelles", "Fontainebleau",
      "Torcy", "Pontault-Combault", "Bussy-Saint-Georges",
    ],
    intro:
      "Livraison à Meaux, Melun, Chelles, Fontainebleau, Torcy, Pontault-Combault, Bussy-Saint-Georges et dans les communes voisines.",
  },
  {
    slug: "yvelines",
    code: "78",
    name: "Yvelines",
    nameWithArticle: "dans les Yvelines",
    templateId: "yvelines",
    cities: [
      "Versailles", "Saint-Germain-en-Laye", "Poissy",
      "Sartrouville", "Mantes-la-Jolie", "Rambouillet",
    ],
    intro:
      "Livraison à Versailles, Saint-Germain-en-Laye, Poissy, Sartrouville, Mantes-la-Jolie, Rambouillet et dans l'ensemble des Yvelines.",
  },
  {
    slug: "essonne",
    code: "91",
    name: "Essonne",
    nameWithArticle: "dans l'Essonne",
    templateId: "essonne",
    cities: [
      "Évry-Courcouronnes", "Massy", "Palaiseau",
      "Corbeil-Essonnes", "Savigny-sur-Orge",
    ],
    intro:
      "Livraison à Évry-Courcouronnes, Massy, Palaiseau, Corbeil-Essonnes, Savigny-sur-Orge et dans tout le département.",
  },
  {
    slug: "hauts-de-seine",
    code: "92",
    name: "Hauts-de-Seine",
    nameWithArticle: "dans les Hauts-de-Seine",
    templateId: "hauts-de-seine",
    cities: [
      "Boulogne-Billancourt", "Nanterre", "Courbevoie", "Colombes",
      "Asnières-sur-Seine", "Levallois-Perret", "Antony",
    ],
    intro:
      "Livraison à Boulogne-Billancourt, Nanterre, Courbevoie, Colombes, Asnières-sur-Seine, Levallois-Perret, Antony et dans les villes voisines.",
  },
  {
    slug: "seine-saint-denis",
    code: "93",
    name: "Seine-Saint-Denis",
    nameWithArticle: "en Seine-Saint-Denis",
    templateId: "seine-saint-denis",
    cities: [
      "Saint-Denis", "Montreuil", "Aubervilliers", "Pantin",
      "Bobigny", "Aulnay-sous-Bois", "Noisy-le-Grand",
    ],
    intro:
      "Livraison à Saint-Denis, Montreuil, Aubervilliers, Pantin, Bobigny, Aulnay-sous-Bois, Noisy-le-Grand et dans toute la Seine-Saint-Denis.",
  },
  {
    slug: "val-de-marne",
    code: "94",
    name: "Val-de-Marne",
    nameWithArticle: "dans le Val-de-Marne",
    templateId: "val-de-marne",
    cities: [
      "Créteil", "Vitry-sur-Seine", "Ivry-sur-Seine", "Vincennes",
      "Maisons-Alfort", "Villejuif", "Saint-Maur-des-Fossés",
    ],
    intro:
      "Livraison à Créteil, Vitry-sur-Seine, Ivry-sur-Seine, Vincennes, Maisons-Alfort, Villejuif, Saint-Maur-des-Fossés et dans tout le Val-de-Marne.",
  },
  {
    slug: "val-d-oise",
    code: "95",
    name: "Val-d'Oise",
    nameWithArticle: "dans le Val-d'Oise",
    templateId: "val-d-oise",
    cities: [
      "Cergy", "Argenteuil", "Sarcelles", "Pontoise",
      "Franconville", "Gonesse",
    ],
    intro:
      "Livraison à Cergy, Argenteuil, Sarcelles, Pontoise, Franconville, Gonesse et dans l'ensemble du Val-d'Oise.",
  },
];

export const getDepartmentBySlug = (slug) =>
  DEPARTMENTS.find((d) => d.slug === slug) || null;

export default DEPARTMENTS;
